<template>
  <div v-loading="loading" class="normal-table-wrap">
    <empty v-if="useEmpty && paging.total === 0" description="暂无数据"></empty>
    <div v-else :class="['normal-table', showPagination ? '' : 'no-paggination']">
      <!-- 表格 -->
      <el-table
        :data="tableData"
        :border="showBorder"
        :show-header="showHeader"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
      >
        <!--表格第一列-->
        <el-table-column
          v-if="firstTableCol.select"
          :type="firstTableCol.type"
          :width="firstTableCol.width"
          :min-width="firstTableCol.minWidth"
          :align="firstTableCol.align"
          :header-align="firstTableCol.headerAlign"
        >
        </el-table-column>
        <!--表格其它列-->
        <el-table-column
          v-for="(value, index) in tableCol"
          :key="index"
          show-overflow-tooltip
          :prop="value.prop"
          :label="value.label"
          :width="value.width"
          :min-width="value.minWidth"
          :align="value.align"
          :header-align="value.headerAlign"
        >
          <template slot-scope="scope">
            <template v-if="value.path">
              <span class="info-item">
                <router-link class="info-link" :to="value.path(scope.row)">{{
                  scope.row[value.prop] || $constants.EMPTY
                }}</router-link>
              </span>
            </template>
            <template v-else-if="!value.slotName">
              <template v-if="value.icon || value.formatter">
                <span class="info-item">
                  <span v-if="value.icon" :class="['iconfont', value.icon, 'info-icon']" />
                  <span v-if="value.formatter" class="text">{{
                    value.formatter(scope.row, scope.column, value)
                  }}</span>
                  <span v-else class="info-text">{{
                    scope.row[value.prop] || $constants.EMPTY
                  }}</span>
                </span>
              </template>
              <template v-else>
                <span class="info-item">
                  <span class="info-text">{{ scope.row[value.prop] || $constants.EMPTY }}</span>
                </span>
              </template>
            </template>
            <template v-else>
              <slot :name="value.slotName" :param="scope"></slot>
            </template>
          </template>
        </el-table-column>
        <!--基础操作-->
        <el-table-column
          v-if="showEdit"
          label="操作"
          :width="operateCol.width"
          :min-width="operateCol.minWidth"
          :align="operateCol.align"
          :header-align="operateCol.headerAlign"
        >
          <template slot-scope="scope">
            <template v-if="operator.length < 7">
              <div class="operate-cell">
                <div
                  v-for="(value, index) in operator"
                  v-show="value.formatter ? value.formatter(scope.row, scope.column, value) : true"
                  :key="value + index"
                  :class="['operate-item', value.class, value.showText ? 'operate-item--both' : '']"
                  @click="value.click(scope.row, scope.column, value)"
                >
                  <div v-if="value.showText">
                    <span :class="['iconfont', value.icon, 'operate-icon']"></span>
                    <span class="operate-text">{{ value.text }}</span>
                  </div>
                  <div v-else>
                    <el-tooltip :content="value.text" placement="top">
                      <span :class="['iconfont', value.icon, 'operate-icon']"></span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <el-tooltip placement="top">
                <div slot="content">
                  <div
                    v-for="(value, index) in operator"
                    v-show="
                      value.formatter ? value.formatter(scope.row, scope.column, value) : true
                    "
                    :key="value + index"
                    class="operate-menu"
                    @click="value.click(scope.row, scope.column, value)"
                  >
                    <img :src="value.icon" alt="" />
                    {{ value.text }}
                  </div>
                </div>
                <i class="el-icon-more"></i>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格 -->
      <!-- 分页 -->
      <pagination
        v-if="showPagination"
        :paging="paging"
        @paginationChanged="onPageChanged"
      ></pagination>
      <!-- 分页 -->
    </div>
  </div>
</template>

<script>
import pagination from './pagination.vue'
export default {
  name: 'NormalTable',
  components: {
    pagination
  },
  props: {
    firstTableCol: {
      type: Object,
      default: () => {
        return {
          select: false,
          width: 55,
          type: 'selection'
        }
      }
    },
    operateCol: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tableCol: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    operator: {
      type: Array,
      default: () => {
        return []
      }
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    paging: {
      type: Object,
      default: () => {
        return {
          total: 0,
          offset: 0,
          limit: 10
        }
      }
    },
    showBorder: {
      type: Boolean,
      default: false
    },
    useEmpty: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: true
    }
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler() {
        this.loading = false
      }
    }
  },
  methods: {
    // 监听table选择框
    handleSelectionChange(selection) {
      // 调用父组件对应的方法 handleSelectionChange
      this.$emit('handleSelectionChange', selection)
    },
    handleRowClick(row, column, event) {
      this.$emit('handleRowClick', row, column, event)
    },
    onPageChanged(info) {
      this.loading = true
      this.$emit('pagination', info)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'normal-table-wrap',
  (
    --cbaas-normal-table-header-background-color: #303c65,
    --cbaas-normal-table-header-border-color: #303c65,
    --cbaas-normal-table-body-border-color: #303c65,
    --cbaas-normal-table-header-color: #8babba,
    --cbaas-normal-table-body-color: #fff,
    --cbaas-normal-table-body-hover-background-color: #49547a,
    --cbaas-normal-table-body-info-link-color: #45c2ff,
    --cbaas-normal-table-body-info-link-visited-color: #45ffb2,
    --cbaas-normal-table-body-info-link-hover-color: #45c2ff99,
    --cbaas-normal-table-body-operate-normal-color: #45c2ff,
    --cbaas-normal-table-body-operate-danger-color: #e95757,
    --cbaas-normal-table-empty-color: #a3afb5
  ),
  (
    --cbaas-normal-table-header-background-color: #fff,
    --cbaas-normal-table-header-border-color: #f6f7f9,
    --cbaas-normal-table-body-border-color: #ebebeb,
    --cbaas-normal-table-header-color: #5a6973,
    --cbaas-normal-table-body-color: #122836,
    --cbaas-normal-table-body-hover-background-color: #f9f9fa,
    --cbaas-normal-table-body-info-link-color: #45c2ff,
    --cbaas-normal-table-body-info-link-visited-color: #45ffb2,
    --cbaas-normal-table-body-info-link-hover-color: #45c2ff99,
    --cbaas-normal-table-body-operate-normal-color: #45c2ff,
    --cbaas-normal-table-body-operate-danger-color: #e95757,
    --cbaas-normal-table-empty-color: #5a6973
  )
);
.normal-table-wrap {
  @include adaptation(
    (
      --cbaas-normal-table-padding-bottom: 80px,
      --cbaas-normal-table-no-pagination-padding-bottom: 40px,
      --cbaas-normal-table-header-height: 40px,
      --cbaas-normal-table-header-fontsize: 12px,
      --cbaas-normal-table-header-border-bottom-width: 1px,
      --cbaas-normal-table-header-text-height: 16px,
      --cbaas-normal-table-selection-header-text-height: 18px,
      --cbaas-normal-table-header-cell-padding: 0 10px 0 0,
      --cbaas-normal-table-header-first-cell-padding: 0 10px 0 24px,
      --cbaas-normal-table-header-last-cell-padding: 0 24px 0 0,
      --cbaas-normal-table-body-height: 50px,
      --cbaas-normal-table-body-fontsize: 12px,
      --cbaas-normal-table-body-border-bottom-width: 1px,
      --cbaas-normal-table-body-text-height: 16px,
      --cbaas-normal-table-body-cell-padding: 0 10px 0 0,
      --cbaas-normal-table-body-first-cell-padding: 0 10px 0 24px,
      --cbaas-normal-table-body-last-cell-padding: 0 24px 0 0,
      --cbaas-normal-table-body-info-icon-fontsize: 16px,
      --cbaas-normal-table-body-info-icon-margin-right: 4px,
      --cbaas-normal-table-body-operate-height: 16px,
      --cbaas-normal-table-body-operate-item-margin-right: 12px,
      --cbaas-normal-table-body-operate-icon-fontsize: 16px,
      --cbaas-normal-table-body-operate-icon-margin-right: 4px,
      --cbaas-normal-table-body-operate-text-fontsize: 12px,
      --cbaas-normal-table-empty-height: 50px,
      --cbaas-normal-table-empty-fontsize: 12px
    )
  );
  height: 100%;
  position: relative;
  min-height: var(--base-main-router-body-avaliable-height-with-action-bar);

  .el-empty {
    height: 100%;
    min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
  }

  .normal-table {
    height: 100%;
    min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
    padding-bottom: var(--cbaas-normal-table-padding-bottom);

    &.no-paggination {
      padding-bottom: var(--cbaas-normal-table-no-pagination-padding-bottom);
    }

    .el-table {
      border-top-width: 0;
      border-left-color: var(--cbaas-normal-table-body-border-color);
      background-color: transparent;
      width: 100%;

      /deep/ {
        .el-table__body-wrapper {
          overflow-x: hidden;
        }

        .el-table__header {
          tr {
            height: var(--cbaas-normal-table-header-height);
            font-size: var(--cbaas-normal-table-header-fontsize);
            font-weight: 400;
            background-color: transparent;

            .el-table__cell {
              border-right-width: 0;
              border-bottom-width: var(--cbaas-normal-table-header-border-bottom-width);
              border-bottom-color: var(--cbaas-normal-table-header-border-color);
              background-color: var(--cbaas-normal-table-header-background-color);

              .cell {
                line-height: var(--cbaas-normal-table-header-text-height);
                height: var(--cbaas-normal-table-header-text-height);
                font-weight: 400;
                white-space: nowrap;
                color: var(--cbaas-normal-table-header-color);
                padding: var(--cbaas-normal-table-header-cell-padding);
              }

              &:first-child .cell {
                padding: var(--cbaas-normal-table-header-first-cell-padding);
              }

              &:last-child .cell {
                padding: var(--cbaas-normal-table-header-last-cell-padding);
              }
            }

            .el-table__cell.el-table-column--selection {
              .cell {
                line-height: var(--cbaas-normal-table-selection-header-text-height);
                height: var(--cbaas-normal-table-selection-header-text-height);
              }
            }
          }
        }

        .el-table__body {
          tr {
            height: var(--cbaas-normal-table-body-height);
            font-size: var(--cbaas-normal-table-body-fontsize);
            font-weight: 400;
            background-color: transparent;

            .el-table__cell {
              border-right-width: 0;
              border-bottom-width: var(--cbaas-normal-table-body-border-bottom-width);
              border-bottom-color: var(--cbaas-normal-table-body-border-color);

              .cell {
                line-height: var(--cbaas-normal-table-body-text-height);
                min-height: var(--cbaas-normal-table-body-text-height);
                white-space: nowrap;
                color: var(--cbaas-normal-table-body-color);
                padding: var(--cbaas-normal-table-body-cell-padding);

                .info-item {
                  .info-link {
                    &:link {
                      color: var(--cbaas-normal-table-body-info-link-color);
                    }

                    &:active {
                      color: var(--cbaas-normal-table-body-info-link-color);
                    }

                    &:visited {
                      color: var(--cbaas-normal-table-body-info-link-visited-color);
                    }

                    &:hover {
                      color: var(--cbaas-normal-table-body-info-link-hover-color);
                    }
                  }

                  .info-icon {
                    font-size: var(--cbaas-normal-table-body-info-icon-fontsize);
                    margin-right: var(--cbaas-normal-table-body-info-icon-margin-right);
                  }
                }

                .operate-cell {
                  display: flex;

                  .operate-item {
                    height: var(--cbaas-normal-table-body-operate-height);
                    color: var(--cbaas-normal-table-body-operate-normal-color);

                    &.operate-danger {
                      color: var(--cbaas-normal-table-body-operate-danger-color);
                    }

                    .operate-icon {
                      font-size: var(--cbaas-normal-table-body-operate-icon-fontsize);
                      margin-right: var(--cbaas-normal-table-body-operate-icon-margin-right);
                    }

                    .operate-text {
                      font-size: var(--cbaas-normal-table-body-operate-text-fontsize);
                      font-weight: 400;
                    }

                    &.operate-item--both:not(:last-child) {
                      margin-right: var(--cbaas-normal-table-body-operate-item-margin-right);
                    }
                  }

                  .operate-item:hover {
                    opacity: 0.8;
                  }
                }
              }

              &:first-child .cell {
                padding: var(--cbaas-normal-table-body-first-cell-padding);
              }

              &:last-child .cell {
                padding: var(--cbaas-normal-table-body-last-cell-padding);
              }
            }

            &:hover {
              .el-table__cell {
                background-color: var(--cbaas-normal-table-body-hover-background-color);
              }
            }
          }
        }

        .el-table__empty-block {
          font-size: var(--cbaas-normal-table-empty-fontsize);
          min-height: var(--cbaas-normal-table-empty-height);

          .el-table__empty-text {
            line-height: var(--cbaas-normal-table-empty-height);
            color: var(--cbaas-normal-table-empty-color);
          }
        }
      }

      &::before {
        background-color: transparent !important;
      }

      &.el-table--border::before {
        background-color: var(--cbaas-normal-table-body-border-color) !important;
      }

      &::after {
        background-color: var(--cbaas-normal-table-body-border-color) !important;
      }
    }
  }
}
</style>
